<template>
  <v-card align="center" justify="center" min-width="21vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_FindClub') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 pt-7">
      <v-form v-if="firstStep" v-model="valid">
        <v-autocomplete v-model="clubSelected" :items="filteredClubs"
                        :rules="clubRule" item-text="name" item-value="id"
                        :label="$t('labelSearch')" :placeholder="$t('hintSearch_FindClub')" 
                        small-chips outlined :no-data-text="$t('noClubFound')"
                        @update:search-input="updateSearch" hide-no-data
                        />
        <p class="mb-6 mt-n3 accent">{{ $t('searchHint') }}</p>
        <v-btn :disabled="!valid" class="mb-3 mt-n2" @click="goToClub">{{ $t('btnSee') }} »</v-btn>
      </v-form>
      <v-container v-else-if="secondStep" fluid>
        <v-row align="center" justify="center">
          <div>
            <v-avatar size="100"><v-img :src="clubObject.imageUrl" contain></v-img></v-avatar>
            <h2 class="mt-3 mb-2 text-center">{{ clubObject.name }}</h2>
            <p class="text-center">{{ clubObject.description }}</p>
            </div>
        </v-row>
        <v-row class="d-flex align-center justify-center text-center mt-1">
          <v-btn class="mr-3" @click="backToClubs">« {{ $t('btnBack_FindClub') }}</v-btn>
          <v-btn @click="joinCommunity">{{ $t('btnJoin') }}</v-btn>
        </v-row>
        <p style="font-size: 14px;" class="text-center mb-2 mt-7">{{ $t('messageTerms') }}
          <a style="font-size: 14px;" href="https://swiset.com/terms-and-conditions/" target="_blank">{{ $t('linkTerms') }}</a></p>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
export default {
  name: "FindClub",
  props: {
    userClubs: Array,
  },
  data() {
    return {
      firstStep: true,
      secondStep: false,
      allAvailableClubs: [],
      clubSelected: '',
      searchText: '',
      clubObject: null,

      // Rules
      valid: false,
      clubRule: [
        c => !!c || 'Select a community',
      ],
    };
  },
  computed: {
    filteredClubs() {
      if (!this.searchText || this.searchText.trim() === '') {
        return [];
      }
      
      return this.allAvailableClubs.filter(club => 
        club.name.toLowerCase() === this.searchText.toLowerCase()
      );
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.allClubs().then((response) => {
        if(response.status < 400)
          response.data.forEach((club) => {
            if(this.userClubs.find(alreadyMember => alreadyMember.club.id === club.id) === undefined)
              this.allAvailableClubs.push(club);
          });
      });
    },
    joinCommunity() {
      let clubMember = {
        club: { id: this.clubObject.id },
        user: { id: this.$store.state.user.id },
        rol: 'PENDING',
        memberSince: new Date(),
      };

      // eslint-disable-next-line no-console
      console.log(clubMember);

      Repository.createClubMember(clubMember).then((response) => {
        if(response.status < 400) {
          alert('Your request was sent!\nWait for the team response.');
          this.$emit('joinClub');
          this.close();
        }
      });
    },
    goToClub() {
      this.firstStep = false;
      this.secondStep = true;
      this.clubObject = this.allAvailableClubs.find((club) => club.id === this.clubSelected);
    },
    backToClubs() {
      this.firstStep = true;
      this.secondStep = false;
    },
    close() {
      this.$emit('closeWindow');
    },
    updateSearch(text) {
      this.searchText = text;
    }
  }
}
</script>



<style scoped>

</style>
